

export const UPDATE_ALL_REPORTS = "UPDATE_ALL_REPORTS"
export const UPDATE_COMPLETED_REPORTS = "UPDATE_COMPLETED_REPORTS"
export const UPDATE_UNCOMPLETED_REPORTS = "UPDATE_UNCOMPLETED_REPORTS"